import type {
  CreateClassTypeDTO,
  CreateInstructorDTO,
  CreateLevelDTO,
  CreateRoomDTO,
} from "@/modules/master/domain/contracts";

/**
 * Mock data สำหรับ dev mode auto fill
 * ข้อมูลจริงที่เตรียมไว้ 5 ชุดสำหรับแต่ละ entity
 */

export const mockClassTypes: CreateClassTypeDTO[] = [
  {
    name: "Hip-hop",
    description: "ສຳລັບຜູ້ທີ່ມັກສະໄໝໃໝ່ ແລະ ສະໄໝເດີ່ນ",
    status: "active",
  },
  {
    name: "Jazz",
    description: "ສຳລັບຜູ້ທີ່ມັກສະໄໝຄລາສິກ ແລະ ສະໄໝເດີ່ນ",
    status: "active",
  },
  {
    name: "Contemporary",
    description: "ສຳລັບຜູ້ທີ່ມັກສະໄໝສະໄໝໃໝ່ ແລະ ສະໄໝເດີ່ນ",
    status: "active",
  },
  {
    name: "Ballet",
    description: "ສຳລັບຜູ້ທີ່ມັກສະໄໝຄລາສິກ ແລະ ສະໄໝເດີ່ນ",
    status: "active",
  },
  {
    name: "K-Pop",
    description: "ສຳລັບຜູ້ທີ່ມັກສະໄໝໃໝ່ ແລະ ສະໄໝເດີ່ນ",
    status: "active",
  },
];

export const mockLevels: CreateLevelDTO[] = [
  {
    name: "ເລີ່ມຕົ້ນ",
    description: "ສຳລັບຜູ້ເລີ່ມຕົ້ນ",
    order: 1,
    status: "active",
  },
  {
    name: "ພື້ນຖານ",
    description: "ສຳລັບຜູ້ທີ່ມີພື້ນຖານແລ້ວ",
    order: 2,
    status: "active",
  },
  {
    name: "ກາງ",
    description: "ສຳລັບຜູ້ທີ່ມີປະສົບການກາງ",
    order: 3,
    status: "active",
  },
  {
    name: "ຂັ້ນສູງ",
    description: "ສຳລັບຜູ້ທີ່ມີປະສົບການຫຼາຍ",
    order: 4,
    status: "active",
  },
  {
    name: "ຊັ້ນສູງສຸດ",
    description: "ສຳລັບຜູ້ທີ່ມີປະສົບການຫຼາຍທີ່ສຸດ",
    order: 5,
    status: "active",
  },
];

export const mockRooms: CreateRoomDTO[] = [
  {
    name: "ຫ້ອງ A",
    capacity: 20,
    description: "ຫ້ອງໃຫຍ່ ສຳລັບຄລາດສ໌ກຸ່ມໃຫຍ່",
    status: "active",
  },
  {
    name: "ຫ້ອງ B",
    capacity: 15,
    description: "ຫ້ອງກາງ ສຳລັບຄລາດສ໌ກຸ່ມກາງ",
    status: "active",
  },
  {
    name: "ຫ້ອງ C",
    capacity: 10,
    description: "ຫ້ອງນ້ອຍ ສຳລັບຄລາດສ໌ສ່ວນຕົວ",
    status: "active",
  },
  {
    name: "ຫ້ອງ D",
    capacity: 25,
    description: "ຫ້ອງໃຫຍ່ສຸດ ສຳລັບຄລາດສ໌ກຸ່ມໃຫຍ່",
    status: "active",
  },
  {
    name: "ຫ້ອງ E",
    capacity: 12,
    description: "ຫ້ອງນ້ອຍ ສຳລັບຄລາດສ໌ສ່ວນຕົວ",
    status: "active",
  },
];

export const mockInstructors: CreateInstructorDTO[] = [
  {
    name: "ສົມຊາຍ ວົງສະວັດ",
    phoneNumber: "020 12345678",
    email: "somchai@example.com",
    employmentType: "full_time",
    payoutRates: [
      {
        workKind: "general_class",
        payoutBasis: "per_hour",
        amountKip: 40000,
      },
      {
        workKind: "private_lesson",
        payoutBasis: "per_hour",
        amountKip: 55000,
      },
      { workKind: "partner", payoutBasis: "per_hour", amountKip: 45000 },
      {
        workKind: "room_rental_assist",
        payoutBasis: "per_session",
        amountKip: 45000,
      },
      {
        workKind: "general_class_assist",
        locationKind: "studio",
        payoutBasis: "per_session",
        amountKip: 50000,
      },
      {
        workKind: "general_class_assist",
        locationKind: "off_site",
        payoutBasis: "per_session",
        amountKip: 70000,
      },
    ],
    status: "active",
    notes: "ມີປະສົບການ 5 ປີ",
  },
  {
    name: "ສຸດາ ພົມມະວົງ",
    phoneNumber: "020 23456789",
    email: "suda@example.com",
    employmentType: "freelance",
    payoutRates: [
      {
        workKind: "general_class",
        payoutBasis: "per_hour",
        amountKip: 50000,
      },
      {
        workKind: "private_lesson",
        payoutBasis: "per_hour",
        amountKip: 65000,
      },
      { workKind: "partner", payoutBasis: "per_hour", amountKip: 50000 },
      {
        workKind: "room_rental_assist",
        payoutBasis: "per_session",
        amountKip: 50000,
      },
      {
        workKind: "general_class_assist",
        locationKind: "studio",
        payoutBasis: "per_session",
        amountKip: 50000,
      },
      {
        workKind: "general_class_assist",
        locationKind: "off_site",
        payoutBasis: "per_session",
        amountKip: 70000,
      },
    ],
    status: "active",
    notes: "ມີປະສົບການ 3 ປີ",
  },
  {
    name: "ວັນນະ ສີລາວົງ",
    phoneNumber: "020 34567890",
    email: "wanna@example.com",
    employmentType: "full_time",
    payoutRates: [
      {
        workKind: "general_class",
        payoutBasis: "per_hour",
        amountKip: 42000,
      },
      {
        workKind: "private_lesson",
        payoutBasis: "per_hour",
        amountKip: 60000,
      },
      { workKind: "partner", payoutBasis: "per_hour", amountKip: 48000 },
      {
        workKind: "room_rental_assist",
        payoutBasis: "per_session",
        amountKip: 48000,
      },
      {
        workKind: "general_class_assist",
        locationKind: "studio",
        payoutBasis: "per_session",
        amountKip: 50000,
      },
      {
        workKind: "general_class_assist",
        locationKind: "off_site",
        payoutBasis: "per_session",
        amountKip: 70000,
      },
    ],
    status: "active",
    notes: "ມີປະສົບການ 7 ປີ",
  },
  {
    name: "ພູມິດ ຈັນທະວົງ",
    phoneNumber: "020 45678901",
    email: "phumit@example.com",
    employmentType: "freelance",
    payoutRates: [
      {
        workKind: "general_class",
        payoutBasis: "per_hour",
        amountKip: 60000,
      },
      {
        workKind: "private_lesson",
        payoutBasis: "per_hour",
        amountKip: 75000,
      },
      { workKind: "partner", payoutBasis: "per_hour", amountKip: 60000 },
      {
        workKind: "room_rental_assist",
        payoutBasis: "per_session",
        amountKip: 60000,
      },
      {
        workKind: "general_class_assist",
        locationKind: "studio",
        payoutBasis: "per_session",
        amountKip: 50000,
      },
      {
        workKind: "general_class_assist",
        locationKind: "off_site",
        payoutBasis: "per_session",
        amountKip: 70000,
      },
    ],
    status: "active",
    notes: "ມີປະສົບການ 4 ປີ",
  },
  {
    name: "ນິລາ ວົງສະວັດ",
    phoneNumber: "020 56789012",
    email: "nila@example.com",
    employmentType: "full_time",
    payoutRates: [
      {
        workKind: "general_class",
        payoutBasis: "per_hour",
        amountKip: 38000,
      },
      {
        workKind: "private_lesson",
        payoutBasis: "per_hour",
        amountKip: 52000,
      },
      { workKind: "partner", payoutBasis: "per_hour", amountKip: 40000 },
      {
        workKind: "room_rental_assist",
        payoutBasis: "per_session",
        amountKip: 40000,
      },
      {
        workKind: "general_class_assist",
        locationKind: "studio",
        payoutBasis: "per_session",
        amountKip: 50000,
      },
      {
        workKind: "general_class_assist",
        locationKind: "off_site",
        payoutBasis: "per_session",
        amountKip: 70000,
      },
    ],
    status: "active",
    notes: "ມີປະສົບການ 6 ປີ",
  },
];

/**
 * ฟังก์ชันสุ่มข้อมูลจาก array
 */
export function getRandomMockData<T>(data: T[]): T {
  const randomIndex = Math.floor(Math.random() * data.length);
  return data[randomIndex]!;
}
